import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

function sessionId() {
  let sid = sessionStorage.getItem("nx_sid");
  if (!sid) {
    sid = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    sessionStorage.setItem("nx_sid", sid);
  }
  return sid;
}

// Anonymous, cookie-less analytics: per-tab session id, no IP or user agent stored.
export function track(type, data = {}) {
  try {
    fetch(`${API}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, session_id: sessionId(), ...data }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // analytics must never break the page
  }
}

export function adminClient(token, onUnauthorized) {
  const client = axios.create({ baseURL: `${API}/admin`, headers: { Authorization: `Bearer ${token}` } });
  client.interceptors.response.use(undefined, (error) => {
    if (error.response?.status === 401) onUnauthorized();
    return Promise.reject(error);
  });
  return client;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : JSON.stringify(e)))
      .join(" ");
  }
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
